var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h36v36h-36z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(3.75 3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.75 6.75-6.75-.75-8.25.75-.75 7.5.75 7.5 7.5.9375 7.5-.9375.75-7.6875z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.826875 18.38625c-.560625-.37875-.94875-.931875-1.160625-1.663125l1.30125-.53625c.118125.45.324375.79875.61875 1.04625.2925.2475.64875.369375 1.065.369375.425625 0 .79125-.129375 1.096875-.388125s.459375-.58875.459375-.988125c0-.40875-.16125-.7425-.48375-1.00125s-.7275-.388125-1.21125-.388125h-.751875v-1.288125h.675c.41625 0 .766875-.1125 1.051875-.3375s.4275-.5325.4275-.924375c0-.34875-.1275-.62625-.3825-.834375s-.5775-.313125-.969375-.313125c-.3825 0-.68625.10125-.91125.305625s-.388125.455625-.49125.751875l-1.288125-.53625c.170625-.48375.48375-.91125.943125-1.280625s1.04625-.555 1.75875-.555c.526875 0 1.00125.10125 1.42125.305625s.75.4875.988125.8475c.238125.361875.35625.766875.35625 1.216875 0 .459375-.110625.8475-.331875 1.16625s-.493125.5625-.815625.733125v.076875c.425625.178125.7725.45 1.04625.815625.271875.365625.40875.8025.40875 1.3125s-.129375.965625-.388125 1.365-.616875.714375-1.070625.943125c-.455625.22875-.9675.3450138-1.535625.3450138-.658125.0018612-1.265625-.1875138-1.82625-.5662638z",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.8125 11.92875-1.42125 1.033125-.714375-1.08375 2.563125-1.84875h.9825v8.720625h-1.41z",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.75 28.5 6.75-6.75-3.375-1.5-3.375 1.5-1.5 3.375z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.25 25.125 1.5 3.375h15v-6.75h-15z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.25 0c-1.243125 0-2.25 1.006875-2.25 2.25v19.5l3.375 1.5 3.375-1.5v-15h15l1.5-3.375-1.5-3.375z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 21.75v4.5c0 1.243125 1.006875 2.25 2.25 2.25h4.5v-6.75z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.75 6.75v15h6.75v-15l-3.375-1.5z",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.5 6.75v-4.5c0-1.243125-1.006875-2.25-2.25-2.25h-4.5v6.75z",
    fill: "#1967d2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.2ccc59d3ceea7fd14c0dfd4d3304402b.svg";
export { ForwardRef as ReactComponent };